import { Tooltip } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";
import { ColumnType } from "antd/lib/table";
import Button from "../../components/shared/button";
import { PaginationToolbar } from "../../components/shared/list/paginationToolbar";
import Table from "../../components/shared/list/table";
import {
  ListViewType,
  useList,
} from "../../components/shared/list/useListHook";
type TableRecord = Record<string, any>;
const columns: ColumnType<TableRecord>[] = [
  {
    key: "name",
    title: "Name",
    dataIndex: "name",
    width: 160,
  },
  {
    key: "age",
    title: "Age",
    dataIndex: "age",
    sorter: (a: TableRecord, b: TableRecord) => a.age - b.age,
    width: 70,
  },
  {
    key: "description",
    title: "Description",
    dataIndex: "description",
    // width: 100,
    // ellipsis: true,
  },

  {
    key: "address",
    title: "Address",
    dataIndex: "address",



    filters: [
      {
        text: "London",
        value: "London",
      },
      {
        text: "New York",
        value: "New York",
      },
    ],
    onFilter: (value, record) => record.address.indexOf(value) === 0,
  },

  {
    title: "...",
    key: "action1",
    ellipsis: true,
    //  fixed: 'right',
    width: 72,
    render: (/*value: string,*/ record: Record<string, any>) => (
      <group data-wrap="no" data-align="center">
        <Button adaptive icon="arrow_downward" text="Download" />
        <separator data-vertical="" data-height="20"></separator>
        <Tooltip title={`Delete ${record.name}`}>
          <Button mini icon="delete" />
        </Tooltip>
 <separator data-vertical="" data-height="20"></separator>
        <Button mini>
          <icon data-icon-weight="300">more_vert</icon>
        </Button>
      </group>
    ),
  },
];



// Initialize an empty array to store the data
const data: TableRecord[] = [];

// Function to generate a random integer within a range
function getRandomInt(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Array of random names
const names: string[] = ['John Brown', 'Jane Doe', 'Michael Smith', 'Emily Johnson', 'David Williams', 'Emma Martinez'];

// Array of random addresses
const addresses: string[] = [
  '123 Main St Anytown',
  '456 Elm St Somewhere',
  '789 Oak St Nowhere',
  '321 Pine St Anywhere',
  '654 Maple St Elsewhere',
];

// Loop to generate random data
for (let i = 1; i <= 15; i++) {
  const randomName: string = names[getRandomInt(0, names.length - 1)];
  const randomAge: number = getRandomInt(20, 60);
  const randomAddress: string = addresses[getRandomInt(0, addresses.length - 1)];

  data.push({
    key: i,
    name: `${randomName}`,
    age: randomAge,
    address: ` ${randomAddress}`,
    description: `${randomName}, I am ${randomAge} years old, living in ${randomAddress}`,
  });
}

const TableDemo = () => {
  const hasData = true;
  const { pagingProps, sort, setSort } = useList({
    viewTypes: [ListViewType.Table],
  });
  const {
    pagination: { current, pageSize },
  } = pagingProps;
  return (

<view data-space="30">



      <group data-border="inset" data-radius="10" data-contain="" data-direction="column" data-wrap="no">
      <group
          data-background="main"
          data-color="white"
          data-space="20"
          data-wrap="no"
          data-align="center"
          data-gap="10"
        >
          <group data-direction="column" data-gap="15" data-space="10">
            <text data-weight="700" data-text-size="xx-large" data-wrap="wrap">
              Table Demo
            </text>
            <text
              
              data-wrap="wrap"
              data-length="300"
              data-line="20"
              data-light=""
            >
              Some info may be visible to other people using Our services. In
              publishing and graphic design ...
            </text>
          </group>
        </group>
<view className="table_cont" data-border="no" data-background="none">
      {/*<div>{process.env.REACT_APP_VERSION}</div>*/}

          <Table
            
            ellipsis={true}
            scroll={{
              y: "100%",
            }}
            bordered={true}
            columns={columns}
            tableLayout={"auto"}
            showHeader={true}
            dataSource={
              hasData
                ? [...data]
                    .sort((a, b) => {
                      const field: string = (sort as any).field;
                      if (field) {
                        const coef = (sort as any).order === "DESC" ? -1 : 1;
                        return coef * (a > b ? -1 : 1);
                      }
                      return 0;
                    })
                    .slice((current! - 1) * pageSize!, current! * pageSize!)
                : []
            }
            pagination={false}
            setSorter={setSort}
            size={"small" as SizeType}
          />
          <PaginationToolbar
          data-space="10"
            {...pagingProps}
            total={hasData ? data.length : 0}
          />

    </view>
</group>


</view>

  );
};

export default TableDemo;
